<header
  class="sticky top-0 z-40 border-b border-slate-200/70 bg-slate-50/80 backdrop-blur
         dark:border-white/10 dark:bg-[#0a0b0f]/80"
>
  <nav class="mx-auto flex max-w-5xl items-center justify-between px-5 py-3 sm:px-8">
    <!-- Brand -->
    <a href="#about" (click)="closeMenu()" class="flex items-center gap-3">
      <img
        src="assets/img/profile-03.jpg"
        alt="Ozan Senturk"
        class="h-9 w-9 rounded-full object-cover ring-2 ring-cyan-500/40"
      />
      <span class="font-semibold tracking-tight">Ozan Senturk</span>
    </a>

    <!-- Desktop links -->
    <div class="hidden items-center gap-1 md:flex">
      <a
        *ngFor="let l of links"
        [href]="l.href"
        class="rounded-md px-3 py-2 text-sm text-slate-600 transition hover:text-cyan-600
               dark:text-slate-300 dark:hover:text-cyan-400"
        >{{ l.label }}</a
      >
      <button
        type="button"
        (click)="theme.toggle()"
        class="ml-2 grid h-9 w-9 place-items-center rounded-lg border border-slate-200 text-slate-600
               transition hover:bg-slate-100 dark:border-white/10 dark:text-slate-300 dark:hover:bg-white/5"
        [attr.aria-label]="theme.isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <i class="fas" [ngClass]="theme.isDark() ? 'fa-sun' : 'fa-moon'"></i>
      </button>
    </div>

    <!-- Mobile controls -->
    <div class="flex items-center gap-1 md:hidden">
      <button
        type="button"
        (click)="theme.toggle()"
        class="grid h-9 w-9 place-items-center rounded-lg border border-slate-200 text-slate-600
               dark:border-white/10 dark:text-slate-300"
        aria-label="Toggle theme"
      >
        <i class="fas" [ngClass]="theme.isDark() ? 'fa-sun' : 'fa-moon'"></i>
      </button>
      <button
        type="button"
        (click)="toggleMenu()"
        class="grid h-9 w-9 place-items-center rounded-lg border border-slate-200 text-slate-600
               dark:border-white/10 dark:text-slate-300"
        aria-label="Toggle menu"
      >
        <i class="fas" [ngClass]="menuOpen ? 'fa-xmark' : 'fa-bars'"></i>
      </button>
    </div>
  </nav>

  <!-- Mobile menu -->
  <div *ngIf="menuOpen" class="border-t border-slate-200/70 md:hidden dark:border-white/10">
    <a
      *ngFor="let l of links"
      [href]="l.href"
      (click)="closeMenu()"
      class="block px-6 py-3 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-white/5"
      >{{ l.label }}</a
    >
  </div>
</header>
